var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49961 10.1002C6.39961 10.1002 4.69961 8.2002 4.69961 6.0002C4.69961 5.4002 4.79961 4.8002 5.09961 4.2002L2.69961 2.2002C1.59961 3.2002 0.699609 4.4002 0.0996094 5.8002C0.0996094 5.9002 0.0996094 6.0002 0.0996094 6.1002C1.49961 9.60019 4.79961 12.0002 8.49961 12.0002C10.0996 12.0002 11.4996 11.6002 12.7996 10.8002L10.8996 9.2002C10.1996 9.8002 9.39961 10.1002 8.49961 10.1002Z",
    fill: "#14ACC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50039 1.9C10.6004 1.9 12.3004 3.8 12.3004 6C12.3004 6.6 12.2004 7.1 12.0004 7.6L14.4004 9.7C15.4004 8.8 16.3004 7.6 16.9004 6.2C16.9004 6.1 16.9004 6 16.9004 5.9C15.5004 2.4 12.2004 0 8.50039 0C7.00039 0 5.60039 0.4 4.40039 1L6.30039 2.6C6.90039 2.2 7.70039 1.9 8.50039 1.9Z",
    fill: "#14ACC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 5.9999C11.0004 4.4999 9.90039 3.3999 8.50039 3.3999C8.10039 3.3999 7.80039 3.4999 7.40039 3.6999L10.9004 6.5999C10.9004 6.3999 11.0004 6.1999 11.0004 5.9999Z",
    fill: "#14ACC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.0002C6 7.5002 7.1 8.6002 8.5 8.6002C9 8.6002 9.4 8.5002 9.8 8.2002L6.2 5.2002C6.1 5.5002 6 5.7002 6 6.0002Z",
    fill: "#14ACC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.599609 0.399902L15.2996 12.6999",
    stroke: "#14ACC5",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 13.1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye_hide.253f1b140ab0db966da4f24f48d7bc9d.svg";
export { ForwardRef as ReactComponent };